module.exports = __webpack_public_path__ + "static/img/12.c5c13d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/12.png
// module id = UUpT
// module chunks = 0